import {IPaginateProducts} from './../../common-dtos/get-all-paginate';
import {EditProductAttributeDto} from './dto/edit-product-attribute-dto';
import ApiService from '../../utils/base-api/api-service';
import {ProductAttributeDetailsDto} from './dto/product-attribute-details-dto';
import {ProductAttributesObjDto} from './dto/product-attributes-dto';
import {
  PredefinedProductAttributeValuesObjDto,
  CreatePredefinedNewValueDto,
} from './dto/predefined-product-attribute-values-dto';
import {PredefinedColorValueSubColorListObjDto} from './dto/predefined-color-value-sub-color-list-dto';
import {CreateValueSubColorDto} from './dto/create-value-sub-color-dto';
import {getPredefinedColorValueSubColorParamsDto} from './dto/get-predefined-sub-color-params-dto';

class ProductAttributesService extends ApiService {
  constructor() {
    super({
      baseURL: '/ProductAttributeAdmin',
    });
  }

  getProductAttributes(input?: any): Promise<ProductAttributesObjDto> {
    return this.post('/List', input);
  }

  getProductAttributeById(
    productAttributeId: string,
  ): Promise<ProductAttributeDetailsDto> {
    return this.get('/GetProductAttributeByID', {
      params: {
        id: productAttributeId,
      },
    });
  }

  editProductAttribute(input: EditProductAttributeDto) {
    return this.post('/Edit', input);
  }

  getPredefinedValues(
    productAttributeId: string,
    queryPaginate: IPaginateProducts,
  ): Promise<PredefinedProductAttributeValuesObjDto> {
    return this.post(`/PredefinedProductAttributeValueList`, undefined, {
      params: {
        ...queryPaginate,
        productAttributeId: productAttributeId,
      },
    });
  }

  createPredefinedValue(input: CreatePredefinedNewValueDto) {
    return this.post('/PredefinedProductAttributeValueCreatePopup', input);
  }

  editPredefinedValue(input: CreatePredefinedNewValueDto) {
    return this.post('/PredefinedProductAttributeValueEditPopup', input);
  }

  predefinedValueDelete(productAttributeId: string) {
    return this.post(
      `/PredefinedProductAttributeValueDelete?id=${productAttributeId}`,
    );
  }

  getPredefinedColorValueSubColorList(
    input: getPredefinedColorValueSubColorParamsDto,
  ): Promise<PredefinedColorValueSubColorListObjDto> {
    return this.get('/PredefinedColorValueSubColorList', {
      params: input,
    });
  }

  createValueSubColor(input: CreateValueSubColorDto) {
    return this.post('/MangeSubColor', input);
  }

  editValueSubColor(input: CreateValueSubColorDto) {
    return this.post('/UpdateSubColor', input);
  }
}

export const productAttributesService = new ProductAttributesService();
